import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Item from "./Item";
import OrganizationListFetching from "./OrganizationListFetching";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import BalanceUpload from "../BalanceUpload/BalanceUpload";

import {
  setBalanceOrganization,
  initBalance,
  setAccountingDates,
  setStartDate,
  setOrganizationsList,
  setBalanceSheetOrganization,
  setOrganizationSelectedItem,
  setModelConfig
} from "Actions";
import { saveAccountingDates, saveBalance, fetchOrganizations } from "Thunks";
import {
  generateAccountingDates,
  recalculateAccountingMonths,
  onSuccess,
  onError,
  compareAccountingDates
} from "Utils";
import { BALANCE_MODELS_CONFIG } from "Config";
import _ from "i18n";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { ModalConfirm } from "tamtam-components";
import stylesButton from "../Common/Modal/Button.local.scss";

class OrganizationList extends Component {
  handleOpenOrganizationData = organization => {
    let { dispatch } = this.props;
    dispatch(push(`/financials/${organization.uen}`));
  };

  handleOpenExternalOrganizationData = organization => {
    // @todo fetch partner token or authorization code
    window.location.href = `https://data.be/en/company/${organization.uen}`;
  };

  // ****  Balance Upload Modal (functions) **** //
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingBalance: false,
      loadingAnnexe: false,
      visible: false,
      slide: 1,
      isOpenModal: false
    };
    this.carousel = React.createRef();
  }

  next = () => {
    this.carousel.current.next();
    this.setState({
      slide: 2
    });
    this.handleUpdateModelConfigOnCanImport();
  };

  previous = () => {
    this.carousel.current && this.carousel.current.goTo(0, false);
    this.setState({
      slide: 1
    });
  };

  nextToAnnexeUpload = () => {
    this.carousel.current.next();
    this.setState({
      slide: 3
    });
  };

  backToBalanceUpload = () => {
    this.carousel.current.prev();
    this.setState({
      slide: 2
    });
  };

  handleShowModal = organization => {
    this.setState({
      visible: true,
      slide: 1
    });

    this.props.dispatch(initBalance());
    this.props.dispatch(setBalanceOrganization(organization));
    this.props.dispatch(
      setStartDate(organization.startDate ? organization.startDate : null)
    );
    this.props.dispatch(
      setAccountingDates(
        organization.accountingDates
          ? organization.accountingDates
          : organization.startDate
            ? recalculateAccountingMonths(
                organization.startDate,
                generateAccountingDates(
                  organization.startDate,
                  new Date().getFullYear() - 1 + "-12-31"
                )
              )
            : [
                {
                  accountingDate: new Date().getFullYear() - 1 + "-12-31"
                }
              ]
      )
    );
  };

  handleOk = (visible = false) => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: visible });
      visible ? this.next() : this.previous();
    }, 3000);
  };

  handleCancel = () => {
    if (this.canImport()) {
      this.setState({ isOpenModal: true });
    } else {
      this.setState({ visible: false });
      this.previous();
    }
  };

  isAccountingDatesGenerated = () => {
    return !(
      this.props.startDate &&
      this.props.accountingDates[0] &&
      this.props.accountingDates[0].months
    );
  };

  handleSaveAccountingDates = () => {
    this.setState({ loading: true });
    this.props.dispatch(saveAccountingDates()).then(
      res => {
        this.onSuccessSaveAccountingDates(res);
        this.setState({ loading: false });
        this.next();
      },
      err => this.onErrorSaveAccountingDates(err)
    );
  };

  onSuccessSaveAccountingDates = res => {
    let { balance, organizationsList } = this.props;

    let list = organizationsList.slice();
    // eslint-disable-next-line array-callback-return
    list.map(item => {
      if (item.id === balance.organization.id) {
        item.accountingDates = this.props.accountingDates;
        item.startDate = this.props.startDate;
        item.stats.configuredExercises = this.props.accountingDates.length;
      }
    });
    this.props.dispatch(setOrganizationsList(list));

    let organization = { ...balance.organization };
    organization.accountingDates = this.props.accountingDates;
    organization.startDate = this.props.startDate;
    this.props.dispatch(setBalanceOrganization(organization));

    onSuccess(res, {
      body: _("updateExercices"),
      title: _("saveSuccess")
    });
  };

  onErrorSaveAccountingDates = err => {
    this.setState({ loading: false });
    onError(err);
  };

  handleSaveBalance = () => {
    this.setState({ loadingBalance: true });
    this.props.dispatch(saveBalance()).then(
      res => {
        this.setState({ loadingBalance: false, visible: false });
        this.previous();
        onSuccess(res, {
          body: _("importBalanceSuccess"),
          title: _("importSuccess")
        });
        this.props.dispatch(fetchOrganizations(this.props.synchro));
      },
      error => {
        this.setState({ loadingBalance: false });
        onError(
          this.renderErrorText(
            error.response.data.errors && error.response.data.errors[0].code
          )
        );
      }
    );
  };

  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170030:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  canImport = () => {
    const { accountingDates, organization, startDate } = this.props;
    return !(
      organization &&
      organization.accountingDates &&
      startDate === organization.startDate &&
      compareAccountingDates(accountingDates, organization.accountingDates)
    );
  };

  handleUpdateModelConfigOnCanImport = () => {
    const { accountingDates, balance } = this.props;
    const { sourceModel } = balance;
    let years = BALANCE_MODELS_CONFIG[sourceModel].years,
      modelConfig = [];
    // modelConfig = {
    //   years: []
    // };

    if (sourceModel === "kluwer_compared_model") {
      for (let i = 0; i < accountingDates.length; i++) {
        modelConfig.push(accountingDates[i].year);
      }
    } else if (years <= accountingDates.length) {
      for (let i = 0; i < years; i++) {
        modelConfig.push(accountingDates[i].year);
      }
    }

    this.props.dispatch(setModelConfig(modelConfig));
  };

  // ****  Balance Upload Modal (functions) END **** //

  // ****  Balance Upload Modal (render) **** //

  renderModalFooterBalanceAccountingConfig = () => {
    return [
      <button
        key="back"
        className={stylesButton.back}
        onClick={this.handleCancel}
      >
        {_("cancel")}
      </button>,

      <button
        key="submit"
        className={stylesButton.save}
        onClick={this.handleSaveAccountingDates}
        disabled={this.isAccountingDatesGenerated()}
      >
        {this.state.loading && (
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("save")}
      </button>,
      <button
        key="next"
        className={stylesButton.import}
        onClick={this.next}
        disabled={this.canImport()}
      >
        {_("import")}
      </button>
    ];
  };

  renderModalFooterBalanceModels = () => {
    return [
      <button key="back" className={stylesButton.back} onClick={this.previous}>
        {_("return")}
      </button>,
      <button
        key="submit"
        className={stylesButton.import}
        style={{ width: "13.520rem" }}
        onClick={this.handleSaveBalance}
        disabled={
          //this.props.balance.modelConfig.length &&
          !this.props.balance.balanceAttachment
          //  ? false
          //  : true
        }
      >
        {this.state.loadingBalance && (
          <img
            src={"/img/icons/tail-spin-green.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("importBalance")}
      </button>
    ];
  };

  // ****  Balance Upload Modal (render) END **** //

  // ****  Balance Sheet Viewer functions **** //

  handleDisplayBalanceSheetViewer = organization => {
    this.props.dispatch(setBalanceSheetOrganization(organization));
    this.props.dispatch(push(`/balance-sheet/${organization.uen}`));
  };

  // ****  Balance Sheet Viewer (functions) END **** //

  // ****  Dashboard functions **** //

  handleDisplayDashboard = ({ organization }) => {
    this.props.dispatch(push(`/dashboard/${organization.uen}`));
  };

  handleSelectClient = id => {
    let { selectedClients } = this.props;

    let newSelectedClients = [...selectedClients];
    if (newSelectedClients.includes(id)) {
      newSelectedClients.splice(newSelectedClients.indexOf(id), 1);
    } else {
      newSelectedClients.push(id);
    }
    this.props.dispatch(setOrganizationSelectedItem(newSelectedClients));
  };

  // ****  Dashboard(functions) END **** //

  handleDisplayFicheClient = organization => {
    let { dispatch, year } = this.props;
    dispatch(push(`/fiche-client/${organization.uen}/${year}`));
  };

  // ****  Render Organizations List  **** //

  render() {
    let { items } = this.props.organizations;
    const {
      fetching,
      fetched,
      balance,
      selectedClients,
      lng,
      loggedAs,
      spaceAs,
      synchro,
      userId,
      year,
      cardsFetching
    } = this.props;
    let { isOpenModal } = this.state;
    if (fetching || cardsFetching) {
      return <OrganizationListFetching />;
    }

    return (
      <div className="medium-12 columns">
        {fetched && items.length ? (
          items.map((item, i) => {
            return (
              <Item
                key={`organization-${item.id}`}
                handleOpenOrganizationData={this.handleOpenOrganizationData}
                handleOpenExternalOrganizationData={
                  this.handleOpenExternalOrganizationData
                }
                handleShowModal={this.handleShowModal}
                handleDisplayBalanceSheetViewer={
                  this.handleDisplayBalanceSheetViewer
                }
                handleDisplayDashboard={this.handleDisplayDashboard}
                handleDisplayFicheClient={this.handleDisplayFicheClient}
                {...item}
                selected={selectedClients.includes(item.id)}
                handleSelectClient={this.handleSelectClient}
                lng={lng}
                loggedAs={loggedAs}
                userId={userId}
                spaceAs={spaceAs}
                synchro={synchro}
                year={year}
              />
            );
          })
        ) : (
          <NotFoundV2 />
        )}
        {/*@todo refactor this modal functions => create component BalanceUploadModal */}
        <TTPReactModal
          title={`${_("configureOrganization")}
            ${balance.organization &&
              balance.organization.name &&
              balance.organization.name.toUpperCase()}`}
          isOpen={this.state.visible}
          inProcess={this.state.loading}
          onCancel={this.handleCancel}
          onConfirm={this.handleOk}
          footer={
            this.state.slide === 1
              ? this.renderModalFooterBalanceAccountingConfig()
              : this.renderModalFooterBalanceModels()
          }
        >
          <BalanceUpload
            carouselRef={this.carousel}
            handleNextToAnnexeUpload={this.nextToAnnexeUpload}
            handleBackToBalanceUpload={this.backToBalanceUpload}
            handleSaveBalance={this.handleSaveBalance}
            loadingBalance={this.state.loadingBalance}
          />
        </TTPReactModal>
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            this.setState({ visible: false });
            this.previous();
            this.setState({ isOpenModal: false });
          }}
          inProcess={false}
          actionFailed={false}
          title={_("cancelConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.organizations.list.fetching,
  fetched: state.organizations.list.fetched,
  organizationsList: state.organizations.list.items,
  balance: state.balance,
  organization: state.balance.organization,
  selectedClients: state.organizations.list.selected,
  accountingDates: state.balance.accountingDates,
  startDate: state.balance.startDate,
  lng: state.params.lng,
  loggedAs: state.auth.loggedAs,
  spaceAs: state.auth.spaceAs,
  userId: state.auth.user && state.auth.user.id,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(OrganizationList);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationList.js